import { render, staticRenderFns } from "./UsersDataTable.vue?vue&type=template&id=890c14a0"
import script from "./UsersDataTable.vue?vue&type=script&lang=ts"
export * from "./UsersDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports